import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {inject} from '@angular/core';
import {OfferService} from '../../service/offer.service';
import {rxMethod} from '@ngrx/signals/rxjs-interop';
import {exhaustMap} from 'rxjs';
import {tap} from 'rxjs/operators';
import {defaultSalesPageSettings, SalesPageSettings} from '../../model/sales-page-settings.model';
import {SpinnerService} from '../../service/spinner.service';
import {SalesOfferState} from './sales-offer-state.model';
import {SearchService} from '../../service/search.service';

export const FinishedOfferSignalStore = signalStore(
  {providedIn: 'root'},
  withState({
    offers: [] as OfferDto[],
    totalElements: 0 as number,
    totalPages: 0 as number,
    pageSettings: {...defaultSalesPageSettings,
      sort: 'FINISHED_OFFER',
      order: 'DESC'},
    searchAggregation: undefined as VehicleOfferSearchAggregation,
    searchParams: {
      'scope': 'FINISHED_OFFERS',
      'allPurchases': true,
      'highestBid': true,
      'onlyOffered': true,
      'purchaseNotReceived': true
    } as VehicleOfferSearchParams
  } as SalesOfferState),
  withMethods((store, offerService = inject(OfferService), spinnerService = inject(SpinnerService), searchService = inject(SearchService)) => ({
    fetchOffers: rxMethod<void>(
      exhaustMap(() => {
        return spinnerService.spinner(offerService.getFinishedUserCompanyOffers(store.pageSettings(),store.searchParams())).pipe(
          tap((page) => {
            patchState(store, {offers: page.content, totalElements: page.totalElements, totalPages: page.totalPages});
          })
        );
      })
    ),
    fetchSearchAggregations: rxMethod<void>(
      exhaustMap(() => {
        return searchService.getSearchAggregationsWithParams(store.searchParams()).pipe(tap(aggregations => {
          patchState(store, {searchAggregation: aggregations});
        }));
      })
    ),
    updatePageSettings(pageSettings: SalesPageSettings): void {
      patchState(store, {pageSettings: pageSettings});
      this.fetchOffers();
    },
    updateSearchParams(searchParams: VehicleOfferSearchParams): void {
      patchState(store, {searchParams: searchParams});
      this.fetchOffers();
    },
    updateSearchAggregation(searchAggregation: VehicleOfferSearchAggregation): void {
      patchState(store, {searchAggregation: searchAggregation});
    }
  }))
);
